"use client"

import type { ComponentProps } from "react"
import type { RecipeVariants } from "@vanilla-extract/recipes"
import clsx from "clsx"

import { useCollectionGridSize } from "~/managers/CollectionManager"

import * as css from "./styles.css"

type CollectionSizeGridStyle = RecipeVariants<typeof css.CollectionSizeGrid>

export type CollectionSizeGridProps = CollectionSizeGridStyle & ComponentProps<"div">

function CollectionSizeGrid({ className, children }: CollectionSizeGridProps) {
  const [collectionGridSize] = useCollectionGridSize()

  return <div className={clsx(css.CollectionSizeGrid({ size: collectionGridSize }), className)}>{children}</div>
}

export default CollectionSizeGrid
